import request from "@/utils/request";
// 骑手列表rider
export function riderList(params) {
  return request({
    url: "delivery/rider/rider-list",
    method: "get",
    params,
  });
}
// 认证审核列表
export function authenticationList(params) {
  return request({
    url: "delivery/rider/attestation",
    method: "get",
    params,
  });
}
// 健康证认证审核列表
export function health_toExamine(params) {
  return request({
    url: "delivery/rider/rider-health",
    method: "get",
    params,
  });
}
// 认证详情
export function attestationInfo(params) {
  return request({
    url: "delivery/rider/attestation-info",
    method: "get",
    params,
  });
}
// 认证详情
export function healthInfo(params) {
  return request({
    url: "delivery/rider/health-info",
    method: "get",
    params,
  });
}
// 编辑认证
export function updateAttestationInfo(data) {
  return request({
    url: "delivery/rider/attestation-info",
    method: "post",
    data,
  });
}
// 健康证编辑认证
export function updateHealthAttestation(data) {
  return request({
    url: "delivery/rider/health-info",
    method: "post",
    data,
  });
}
// 删除骑手
export function deleteRider(data) {
  return request({
    url: "delivery/rider/del-rider",
    method: "post",
    data,
  });
}
// 等级列表
export function levelList(params) {
  return request({
    url: "delivery/level/index",
    method: "get",
    params,
  });
}
// 等级列表
export function getCurlevelNum(params) {
  return request({
    url: "delivery/rider/level-rider",
    method: "get",
    params,
  });
}
// 新增等级
export function saveLevel(data) {
  return request({
    url: "delivery/level/save",
    method: "post",
    data,
  });
}
export function getSaveLevel(params) {
  console.log(params);
  return request({
    url: "delivery/level/save",
    method: "get",
    params,
  });
}
// 奖惩列表
export function sanctionList(params) {
  return request({
    url: "delivery/sanction/index",
    method: "get",
    params,
  });
}
// 奖惩保存
export function sanctionSave(data) {
  return request({
    url: "delivery/sanction/save",
    method: "post",
    data,
  });
}
// 查看奖惩
export function getSanction(params) {
  return request({
    url: "delivery/sanction/save",
    method: "get",
    params,
  });
}
// 删除奖惩
export function sanctionDelete(data) {
  return request({
    url: "delivery/sanction/del-sanction",
    method: "post",
    data,
  });
}
// 骑手认证操作
export function riderOperate(data) {
  return request({
    url: "delivery/rider/attestation-operate",
    method: "post",
    data,
  });
}
// 健康证认证
export function healthAuthentication(data) {
  return request({
    url: "delivery/rider/health-operate",
    method: "post",
    data,
  });
}
// 选择骑手
export function selectRider(params) {
  return request({
    url: "delivery/rider/select-rider",
    method: "get",
    params,
  });
}
// 选择骑手等级
export function selectRiderLevel(params) {
  return request({
    url: "delivery/rider/select-level",
    method: "get",
    params,
  });
}
// 骑手等级编辑
export function riderSave(data) {
  return request({
    url: "delivery/rider/save",
    method: "post",
    data,
  });
}
// 等级信息获取
export function riderInfo(params) {
  return request({
    url: "delivery/rider/save",
    method: "get",
    params,
  });
}
export function gradeDel(data) {
  return request({
    url: "delivery/level/delete",
    method: "post",
    data,
  });
}

export function getMerchantId(params) {
  return request({
    url: 'delivery/rider/get-mini-user',
    method: 'get',
    params
  })
}
